export default {
  install(Vue) {
    Vue.prototype.$goBack = function goBack() {
      this.$router.go(-1);
    };

    Vue.prototype.$toggleItemPreenchidoBarraProgresso = function (
      item,
      shouldAdd,
      itemsPreenchidos = []
    ) {
      if (!Array.isArray(itemsPreenchidos)) {
        return shouldAdd ? [item] : [];
      }

      const index = itemsPreenchidos.indexOf(item);

      if (shouldAdd && index === -1) {
        itemsPreenchidos.push(item);
      } else if (!shouldAdd && index > -1) {
        itemsPreenchidos.splice(index, 1);
      }

      return itemsPreenchidos;
    };

    Vue.prototype.$ehAulaFutura = function (data) {
      if (!data) return false;

      const dataDaAula = data.includes("/")
        ? data.split("/").reverse().join("-")
        : data.slice(0, 10);

      const hoje = new Date();
      const mes = `${hoje.getMonth() + 1}`.padStart(2, "0");
      const dia = `${hoje.getDate()}`.padStart(2, "0");

      return dataDaAula > `${hoje.getFullYear()}-${mes}-${dia}`;
    };

    Vue.prototype.$checkTotallyFilled = function (
      isTotalFilled,
      propriedade = "totalmentePreenchido"
    ) {
      this[propriedade] = isTotalFilled;
      return isTotalFilled;
    };
  },
};
